
function vehicles(state={sortBy:null}, action) {
  switch (action.type) {
    case "SORT_VEHICLES":

      return {
        ...state,
        sortBy: action.payload || null
      }

    default:
      return state
  }
}

export default vehicles


const vehicleLabel = (nickname, make, model) => {
  if (nickname) {
    return nickname
  }

  var name = make
  if (model) {
    name += " " + model
  }
  return name
}



export const getVehicles = state => state.models.vehicles;

export const getVehiclesSorted = state =>{
  const { sortBy } = state.account.vehicles

  if (sortBy=='name')
    return getVehicles(state)
    .map(v=>({...v, name: vehicleLabel(v.nickname, v.make, v.model)}))
    .sort(function(a, b) {
      var nameA = a.name.toUpperCase(); // ignore upper and lowercase
      var nameB = b.name.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    })

  // else
  return getVehicles(state)
}



// WEBPACK FOOTER //
// ./src/account/vehicles/reducer.js